module.exports = __webpack_public_path__ + "b-search.png?5a47d1a5ab1bc92b929e69f46fb4a737";